<div class="table-container">
  <div class="buttons-header">
    @if (sorting.length) {
      <button class="reset-sorting button2-impaired" (click)="resetSorting()">
        Отключить сортировку
      </button>
    }

    <div #columnFilterButton>
      <app-multi-select
        [isVersionImpaired]="true"
        [dropdownWidth]="columnFilterButton.offsetWidth - 2"
        [options]="pcColumnsFilter"
        (choose)="changeColumnFilter($event)"
        [overlayPosition]="columnSettingOverlayPosition"
        (isOpenDropDownChanged)="activeColumnSetting = $event"
        [dropdownMaxHeight]="400"
      >
        <div class="center">
          <app-button-icon
            [iconName]="activeColumnSetting ? icons.Close : icons.BigTriangleDown"
            [isActive]="activeColumnSetting"
            [classSize]="'medium-impaired'"
            buttonName="{{ 'VERSION_VISUALLY_IMPAIRED.VISIBILITY_SETTING' | translate }}"
          ></app-button-icon>
        </div>
      </app-multi-select>
    </div>
  </div>

  <div class="view">
    <div class="wrapper">
      <table class="table">
        <thead>
          <tr>
            @if (staticColumns && staticColumns.length > 0) {
              <th class="first-col sticky-col h3-impaired-dark header-text">
                {{ staticColumns[0].title }}
              </th>

              <th
                (click)="setSorting(staticColumns[1].name, staticColumns[1].type)"
                [class.number-text]="staticColumns[1].type === 'NUMBER' || staticColumns[1].type === 'numeric' || staticColumns[1].type === 'INTEGER'"
                class="second-col sticky-col h3-impaired-dark header-text"
              >
                <div class="table-title-container">
                  {{ staticColumns[1].title }}
                  @if (isSortActive(staticColumns[1].name)) {
                    <app-impaired-icon
                      [invertColor]="true"
                      [iconName]="isSortDescending(staticColumns[1].name) ? icons.ImpairedUp : icons.ImpairedDown"
                    ></app-impaired-icon>
                    <p class="sort-counter">{{ getSortCounter(staticColumns[1].name) }}</p>
                  }
                </div>
              </th>
            }

            @for (column of pcColumnsFilter; track column.name) {
              @if (column.isSelected) {
                <th
                  (click)="setSorting(column.name, column.type!)"
                  [class.number-text]="column.isNumber"
                  class="h3-impaired-dark header-text header-text-dynamic"
                >
                  <div class="table-title-container">
                    {{ column.title }}
                    @if (isSortAvailable(column.type!) && isSortActive(column.name)) {
                      <app-impaired-icon
                        [invertColor]="true"
                        [iconName]="isSortDescending(column.name) ? icons.ImpairedUp : icons.ImpairedDown"
                      ></app-impaired-icon>
                      <p class="sort-counter">{{ getSortCounter(column.name) }}</p>
                    }
                  </div>
                </th>
              }
            }
          </tr>
        </thead>
        <tbody *ngLet="fileData$ | async as allFilesData">
          @if (formObject) {
            <tr [formGroup]="formObject">
              @if (staticColumns && staticColumns.length > 0) {
                <td class="first-col sticky-col text-content">
                  <!--                <input (keyup.enter)="changeCriteria()" class="body1-impaired search-input" [formControlName]="staticColumns[0].name"  placeholder="{{ 'DATA.TABLE_FILTER.SEARCH' | translate }}" />-->
                </td>
                <td class="second-col sticky-col text-content">
                  <input
                    (keyup.enter)="changeCriteria()"
                    class="sticky-col body1-impaired search-input"
                    [formControlName]="staticColumns[1].name"
                    placeholder="{{ 'DATA.TABLE_FILTER.SEARCH' | translate }}"
                  />
                </td>
                @for (column of pcColumnsFilter; track column.name) {
                  @if (column.isSelected) {
                    <td class="text-content-dynamic">
                      <input
                        (keyup.enter)="changeCriteria()"
                        class="body1-impaired search-input"
                        [formControlName]="column.name"
                        placeholder="{{ 'DATA.TABLE_FILTER.SEARCH' | translate }}"
                      />
                    </td>
                  }
                }
              }
            </tr>
          }

          @for (data of currentData; track $index) {
            <tr class="row" (click)="goItem(data)">
              @if (staticColumns && staticColumns.length > 0 && data) {
                <td class="first-col sticky-col body1-impaired text-content">
                  {{ data[staticColumns[0].name] }}
                </td>

                <td
                  [class.number-text]="staticColumns[1].type === 'NUMBER' || staticColumns[1].type === 'numeric' || staticColumns[1].type === 'INTEGER'"
                  class="second-col sticky-col body1-impaired text-content"
                >
                  {{ data[staticColumns[1].name] }}
                </td>
              }
              @for (column of pcColumnsFilter; track column.name) {
                @if (column.isSelected) {
                  <td [class.number-text]="column.isNumber"
                      class="body1-impaired text-content-dynamic">
                    {{ getColumnValue(data, column.name, column.type, allFilesData) }}
                  </td>
                }
              }
            </tr>
          }
        </tbody>
      </table>
    </div>

    <app-impaired-pagination
      #paginator
      (paginatorChanged)="paginatorChanged($event)"
      [allCount]="(allCatalogCount$ | async) ?? 0"
    ></app-impaired-pagination>
  </div>
</div>
